import Vue from "vue";

export function createSlideStyleData(vueModel) {
	return new Vue({
		data() {
			return {
				dark: vueModel.dark,
				scale: 1,
				origin: { x: 0, y: 0 },
				viewerWidth: 0,
				viewerHeight: 0,
				gridSize: vueModel.gridSize,
				availableStencils: vueModel.availableStencils
			};
		}
	})
}